import { getApiBaseUrl } from '@/config/production';
import { SessionManager } from '@/utils/sessionManager';

// Garantir que não há barra dupla na construção da URL
const getApiBase = () => {
  const base = getApiBaseUrl();
  return base.replace(/\/+$/, ''); // Remove barras finais
};

const API_BASE = getApiBase();

export interface Notification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'success' | 'error';
  read: boolean;
  hidden?: boolean;
  link?: string;
  metadata?: any;
  created_at: string;
}

export const NotificationService = {

  async markAsRead(id: string): Promise<Notification> {
    const token = SessionManager.getToken();
    const response = await fetch(`${API_BASE}/api/notifications/${id}/read`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to mark notification as read');
    return response.json();
  },

  async markAllAsRead(excludeWorkflowPending: boolean = true): Promise<void> {
    const token = SessionManager.getToken();
    const url = `${API_BASE}/api/notifications/read-all${excludeWorkflowPending ? '?excludeWorkflowPending=true' : '?excludeWorkflowPending=false'}`;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to mark all notifications as read');
  },

  async delete(id: string): Promise<void> {
    const token = SessionManager.getToken();
    const response = await fetch(`${API_BASE}/api/notifications/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to delete notification');
  },

  async hide(id: string): Promise<Notification> {
    const token = SessionManager.getToken();
    const response = await fetch(`${API_BASE}/api/notifications/${id}/hide`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to hide notification');
    return response.json();
  },

  async deleteAll(): Promise<void> {
    const token = SessionManager.getToken();
    const response = await fetch(`${API_BASE}/api/notifications`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to delete all notifications');
  },

  async findAll(includeHidden: boolean = false): Promise<Notification[]> {
    const token = SessionManager.getToken();
    if (!token) return [];
    
    const url = `${API_BASE}/api/notifications${includeHidden ? '?includeHidden=true' : ''}`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch notifications');
    return response.json();
  }
};
